import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import TrackView from './components/TrackView';
import StepView from './components/StepView';
import Dangal from './components/Dangal';
import AdminPage from './components/AdminPage';
import AdminPerson from './components/AdminPerson';
import MyShagird from './components/MyShagird';
import RequireAuth from './components/RequireAuth';
import RequireAdmin from './components/RequireAdmin';
import RequireStaff from './components/RequireStaff';
import ActivityTracker from './components/ActivityTracker';
import Heartbeat from './components/Heartbeat';

export default function App() {
  return (
    <>
      {/* First-party analytics beacon (pageview/dwell → events collection). */}
      <ActivityTracker />
      <Heartbeat />
      <Routes>
        {/* "/" is the landing: sign-in when signed-out, trails when authorized. */}
        <Route path="/" element={<Home />} />
        <Route
          path="/track/:trackId"
          element={
            <RequireAuth>
              <TrackView />
            </RequireAuth>
          }
        />
        <Route
          path="/track/:trackId/step/:stepId"
          element={
            <RequireAuth>
              <StepView />
            </RequireAuth>
          }
        />
        <Route
          path="/dangal"
          element={
            <RequireAuth>
              <RequireStaff>
                <Dangal />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <RequireStaff>
                <RequireAdmin>
                  <AdminPage />
                </RequireAdmin>
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/admin/people/:uid"
          element={
            <RequireAuth>
              <RequireStaff>
                <RequireAdmin>
                  <AdminPerson />
                </RequireAdmin>
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route
          path="/shagird"
          element={
            <RequireAuth>
              <RequireStaff>
                <MyShagird />
              </RequireStaff>
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
